import { TableDetailsInstallationDto } from "../../services/tables/dto/table-details-dto";

export class Installation {
  name: string;
  instagram: any;
  bannerImage: any;
  thumbnail: any;
  timezone: string;
  isOpened: boolean;
  pipefy_current_phase?: string;
  galaxpay_billing?: number;
  googleBusinessUrl?: string;

  constructor(installation: TableDetailsInstallationDto) {
    this.name = installation.name;
    this.instagram = installation.instagram;
    this.bannerImage = installation.bannerImage;
    this.thumbnail = installation.thumbnail;
    this.timezone = installation.timezone;
    this.isOpened = installation.isOpened;
    this.pipefy_current_phase = installation.pipefy_current_phase;
    this.galaxpay_billing = installation.galaxpay_billing;
    this.googleBusinessUrl = installation.googleBusinessUrl;
  }
}
